import { useDispatch } from 'react-redux';

import { useUrlSearchParams } from 'utils/customHooks/useUrlSearchParams';
import { useRemoveQueryParams } from 'utils/customHooks/useRemoveQueryParams';

import { AppDispatch } from '../../../../store/store';
import ProfileDrawer from '../profile/ProfileDrawer';
import { setSelectedVisitor } from '../../../../store/slices/visitsSlice';

import VisitorList from './formComponents/VisitorList';

const VisitorsTab = () => {
  const dispatch: AppDispatch = useDispatch();
  const { visitorId } = useUrlSearchParams();
  const removeQueryParams = useRemoveQueryParams();

  const handleDrawerClose = () => {
    removeQueryParams(['visitorId']);
    dispatch(setSelectedVisitor(null));
  };

  return (
    <>
      <VisitorList />
      {visitorId && (
        <ProfileDrawer open={Boolean(visitorId)} onClose={handleDrawerClose} />
      )}
    </>
  );
};

export default VisitorsTab;
